import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import api, { fmtIDR } from "../../lib/api";
import { errMsg } from "../admin/ui";
import { StatusBadge, fmtQty, perLabel, openJobChat, FAULTS } from "./shared";
import RepSummary from "./RepSummary";

function ReasonAction({ a, path, label, testId, onDone, cls }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const send = async () => {
    try { await api.post(`/allocations/${a.id}/${path}`, { reason }); toast.success("Terkirim ke Admin"); setOpen(false); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!open) return <button data-testid={`${testId}-${a.id}`} onClick={() => setOpen(true)} className={`text-[11px] font-bold border rounded-sm px-2.5 py-1 ${cls}`}>{label}</button>;
  return (
    <div className="flex gap-1.5 w-full sm:w-auto">
      <input data-testid={`${testId}-reason-${a.id}`} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Alasan (min. 5 karakter)"
        className="flex-1 sm:w-56 bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] rounded-sm px-2 py-1 text-xs outline-none" />
      <button data-testid={`${testId}-send-${a.id}`} disabled={reason.trim().length < 5} onClick={send} className="text-[11px] font-bold bg-[#D4AF37] text-[#101114] rounded-sm px-2.5 disabled:opacity-40">Kirim</button>
      <button onClick={() => setOpen(false)} className="text-[11px] text-[#A8A8AD] px-1">Batal</button>
    </div>
  );
}

export default function MyAllocations() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const load = () => api.get("/my/allocations").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);
  if (!data) return <div className="text-[#A8A8AD]">Memuat...</div>;
  return (
    <div data-testid="my-allocations">
      <RepSummary rep={data.reputation} />
      <div className="space-y-3">
        {data.items.map((a) => (
          <div key={a.id} data-testid={`my-alloc-${a.id}`} className="bg-[#202127] border border-[#35353B] hover:border-[#D4AF37]/50 rounded-lg p-4 transition-colors">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="font-mono text-[10px] tracking-widest text-[#D4AF37]">{a.alloc_no}</div>
                <div className="text-[#F5F3ED] font-semibold">{fmtQty(a.quantity)} {a.item_name}</div>
                <div className="text-xs text-[#A8A8AD]">{a.game_name} · {a.server_name}{a.faction ? ` · ${a.faction}` : ""} · {new Date(a.taken_at).toLocaleString()}</div>
              </div>
              <div className="text-right">
                <div data-testid={`my-alloc-total-${a.id}`} className="text-lg font-bold text-[#D4AF37]">{fmtIDR(a.total_idr)}</div>
                <div className="text-[11px] text-[#A8A8AD]">Harga sepakat {fmtIDR(a.price_per_unit_idr)}{perLabel(a.price_per_qty)}</div>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2 mt-3">
              <StatusBadge kind="alloc" status={a.status} testId={`my-alloc-status-${a.id}`} />
              {a.fault && <span className="text-[11px] text-[#A8A8AD]">{FAULTS[a.fault]}</span>}
              {a.dispute && <span className="text-[11px] text-[#F2D98D]">Sengketa: {a.dispute.status === "open" ? "sedang ditinjau" : "selesai ditinjau"}</span>}
              <div className="flex-1" />
              <button data-testid={`my-alloc-chat-${a.id}`} onClick={() => openJobChat(navigate, { allocation_id: a.id })} className="inline-flex items-center gap-1 text-[11px] font-bold text-[#D4AF37] border border-[#D4AF37]/50 rounded-sm px-2.5 py-1 hover:bg-[#D4AF37] hover:text-[#101114] transition-colors"><MessageCircle size={12} /> PESAN ADMIN</button>
              {a.status === "committed" && <ReasonAction a={a} path="request-cancel" label="Minta Pembatalan" testId="my-alloc-cancel" onDone={load} cls="border-[#F06464] text-[#F06464]" />}
              {a.status === "cancelled" && a.fault === "supplier" && !(a.dispute?.status === "open") && <ReasonAction a={a} path="dispute" label="Ajukan Sengketa" testId="my-alloc-dispute" onDone={load} cls="border-[#F2D98D] text-[#F2D98D]" />}
            </div>
          </div>
        ))}
        {data.items.length === 0 && <div className="text-center py-16 text-[#A8A8AD]">Belum ada alokasi. Ambil job di tab Available Jobs.</div>}
      </div>
    </div>
  );
}
